module.exports = __webpack_public_path__ + "img/live3.320b69a0.png";